import { useTranslations } from 'hooks/useTranslations';
import { ICaseDashboard } from 'models/cases';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCaseDashboard } from 'requests/case';
import { EPeriod } from './helpers';

export const useCaseDashboard = () => {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState<ICaseDashboard>();

  const getDashboardData = async (period: EPeriod, licenceAuthorityUniqueIds: string[]) => {
    const result = await getCaseDashboard(period, licenceAuthorityUniqueIds);
    setDashboardData(result ?? []);
  };

  return { getDashboardData, dashboardData };
};
